import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { regisActions } from '../../../store/actions'
import history from '../../../route/history'
import $ from 'jquery'
import Alert from '../../../module/alert/Alert'

const LoginIntro = (props) => {
  const [state, setState] = useState({
    isShowLogin: false, //uth 로그인 정보 입력창
    isType: '', //가입구분
  })

  useEffect(() => {
    $('.join-intro a').on('click', function () {
      $(this).addClass('on').siblings('a').removeClass('on')
    })
  }, [])

  const goNext = () => {
    let type = state.isType
    // console.log('type : ' + type)
    if (type === 'user') {
      //props.setJoinFlag(type)
      setState({ ...state.isShowLogin, isShowLogin: false })
      history.replace({ pathname: '/login' })
    } else if (type === 'corp') {
      //props.setJoinFlag(type)
      setState({ ...state.isShowLogin, isShowLogin: false })
      history.replace({ pathname: '/loginCorp' })
    }
  }

  const setIsNormReg = () => {
    setState({ ...state, isType: 'user' })
    history.push({ pathname: '/login', state: { isType: 'user' } })
  }

  const setIsCorpReg = () => {
    setState({ ...state, isType: 'corp' })
    history.push({ pathname: '/loginCorp', state: { isType: 'corp' } })
  }

  const cancel = () => {
    setState({ ...state.isShowLogin, isShowLogin: false })

    let join = document.getElementsByClassName('join-user')
    for (let i = 0; i < join.length; i++) {
      join[i].classList.remove('on')
    }
  }

  return (
    <React.Fragment>
      {/* <Alert /> */}
      <div id="contents">
        <div className="content-header type2">
          {/* mobile 뒤로가기 버튼 */}
          <a
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          <h2>로그인</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <em>로그인</em>
          </div>
        </div>

        <div className="join-wrap">
          <div className="join-intro">
            <button className="join-user cursor" onClick={setIsNormReg}>
              개인회원
            </button>
            <button className="join-user cursor" onClick={setIsCorpReg}>
              기업회원
            </button>
          </div>
          {/* <div className="btn-block center">
            <a onClick={goNext}  className="btn-primary lg modal-popup cursor">
              다음 단계로
            </a>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {
  setJoinFlag: regisActions.setJoinFlag,
}

export default connect(mapStateToProps, actionCreators)(LoginIntro)
